import { render, staticRenderFns } from "./AuctionCard.vue?vue&type=template&id=111ba211&scoped=true&"
import script from "./AuctionCard.vue?vue&type=script&lang=ts&"
export * from "./AuctionCard.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionCard.vue?vue&type=style&index=0&id=111ba211&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111ba211",
  null
  
)

export default component.exports